import React, { useEffect } from 'react';
import './Gallery.css';

function Gallery() {
  useEffect(() => {
    // Curator.io Script laden
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.charset = 'UTF-8';
    script.src = 'https://cdn.curator.io/published/b5a6cc70-eb89-4aa1-94f3-e0c7a3967ae3.js';
    
    const firstScript = document.getElementsByTagName('script')[0];
    firstScript.parentNode.insertBefore(script, firstScript);

    return () => {
      // Cleanup: Script entfernen beim Unmount
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  return (
    <section
      className="gallery"
      style={{
        maxWidth: '1050px',
        margin: '0 auto',
        backgroundColor: '#000',
        backgroundImage: 'none',
      }}
    >
      <div className="gallery-header">
        <h2>@milchkettenmusik auf Instagram</h2>
      </div>
      
      {/* Curator.io Instagram Feed */}
      <div id="curator-feed-mkm-layout">
        <a href="https://curator.io" target="_blank" rel="noopener noreferrer" className="crt-logo crt-tag">
          Powered by Curator.io
        </a>
      </div>
      
      <div className="instagram-cta" style={{  margin: '0 auto' }}>
        <a 
          href="https://www.instagram.com/milchkettenmusik" 
          target="_blank" 
          rel="noopener noreferrer"
          className="instagram-link"
        >
          Auf Instagram ansehen →
        </a>
      </div>
    </section>
  );
}

export default Gallery;


